import {
    getGymTvChannels,
    createGymTvChannel,
    getGymTvChannelById,
    updateGymTvChannel,
    deleteGymTvChannel,
    addGymTvChannelItem,
    deleteGymTvChannelItem,
    duplicateGymTvChannel,
    updateGymTvChannelItem,
    getGymTvClassesByRoomNumber,
} from './gymTvRequestConfigs';

class GymTvApi {
    getGymTvChannels = getGymTvChannels;
    createGymTvChannel = createGymTvChannel;
    getGymTvChannelById = getGymTvChannelById;
    updateGymTvChannel = updateGymTvChannel;
    deleteGymTvChannel = deleteGymTvChannel;
    addGymTvChannelItem = addGymTvChannelItem;
    deleteGymTvChannelItem = deleteGymTvChannelItem;
    duplicateGymTvChannel = duplicateGymTvChannel;
    updateGymTvChannelItem = updateGymTvChannelItem;
    getGymTvClassesByRoomNumber = getGymTvClassesByRoomNumber;
}

class GymTvFactory {
    gymTv = GymTvApi;
    create() {
        return new this.gymTv();
    }
}

export const gymTv = new GymTvFactory();



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/GymTvApi/index.js